// prism css
// all themes https://github.com/PrismJS/prism/tree/1d5047df37aacc900f8270b1c6215028f6988eb1/themes
require("prismjs/themes/prism-tomorrow.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
require("gitalk/dist/gitalk.css")

const {
    GitalkContainer,
    BlogLoadedEvent,
} = require("./src/templates/blog-post")

const Gitalk = require("gitalk")

const gitalk = new Gitalk({
    clientID: "290e223345b46fd5a151",
    clientSecret: "31f563a7703822b3144b507471b808c947a907f5",
    repo: "blog-comments",
    owner: "dhruv004",
    admin: ["dhruv004"],
    proxy:
        "https://shielded-brushlands-08810.herokuapp.com/https://github.com/login/oauth/access_token",
})

//TODO: find a better solution
document.addEventListener(BlogLoadedEvent, (event) => {
    setTimeout(() => {
        if (document.getElementById("gitalk-container")) {
            gitalk.render(GitalkContainer)
        }
    }, 1000)
})

// doesn't work without an export so this line is needed
exports.onRouteUpdate = () => {}
